<template>
    <div id="header" class="d-flex flex-row justify-content-around">
        <div id="mercureLogo"></div>
    </div>
</template>

<script>
export default {
  name: 'MercureRatesHorizontalV1Header',
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
    test () {
      return this.$route.query.test
    }
  }
}
</script>

<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../_mercure.scss";

#header {
    width: 100%;
    @include heightPercent(145);
    font-size: 1.3rem;
    font-family: "HouschkaAltPro-DemiBold";
    color: $purple;
    text-transform: uppercase;
    text-align: center;

    #mercureLogo {
        @include widthPercent(233);
        height: 100%;
        background: url(./assets/logoMercure.png) no-repeat;
        background-size: contain;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/mercure/rates/horizontal/v1/header.vue